import { render, staticRenderFns } from "./PageRefer.vue?vue&type=template&id=7f040ed6&"
import script from "./PageRefer.vue?vue&type=script&lang=js&"
export * from "./PageRefer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports